export const HeatNetworkIcon = ({ className, strokeWidth = 2 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true">
    <path d="M12 2.5c.6 2 2.8 3.2 2.8 5.6a2.8 2.8 0 0 1-5.6 0c0-1.2.6-2 1.2-2.6.2 1 .8 1.5 1.3 1.5-.4-1.6-.2-3 .3-4.5Z" />
    <path d="M2 15h6a2 2 0 0 1 2 2v4" />
    <path d="M22 15h-6a2 2 0 0 0-2 2v4" />
    <path d="M2 19h3" />
    <path d="M22 19h-3" />
    <path d="M12 11v4" />
    <path d="M9 15h6" />
  </svg>
);
